import { Mortgages } from './Mortgages';
import { fixNaN } from '../utils/Operations';

export class PropertyInfo {
  constructor(data = {}) {
    this.propertyValue = data?.propertyValue || 0;
    this.mortgages = data?.mortgages;
  }

  static setPropertyInfo(data = {}) {
    const parsedPrincipalInterest = fixNaN(parseFloat(data?.estimatedPrincipalAndInterest));
    const parsedTaxes = fixNaN(parseFloat(data?.estimatedTaxes));
    const parsedPMI = fixNaN(parseFloat(data?.estimatedMortgageInsurance));
    const parsedPropertyInsurance = fixNaN(parseFloat(data?.estimatedPropertyInsurance));
    const parsedFloodInsurance = fixNaN(parseFloat(data?.estimatedFloodInsurance));
    const monthlyPayment = parsedPropertyInsurance + parsedFloodInsurance + parsedPMI + parsedPrincipalInterest + parsedTaxes;

    const info = {
      propertyValue: data?.estimatedHomeValue || 0,
      mortgages: [
        new Mortgages(
          data.estimatedMortageBalance,
          data.estimatedInterestRate,
          monthlyPayment,
          'mortgage',
        ),
      ],
    };

    if (data.estimatedSecondMortgageBalance) {
      info.mortgages.push(
        new Mortgages(
          data.estimatedSecondMortgageBalance || 0,
          data.estimatedSecondInterestRate || 0,
          data.estimatedSecondMonthlyPayment || 0,
          '2nd mortgage',
        ),
      );
    }

    return new PropertyInfo(info);
  }

  static setFromDB(propertyValue, data) {
    const info = {
      propertyValue,
      mortgages: data ? Array.from(data) : null,
    };

    return new PropertyInfo(info);
  }
}
